export default "__VITE_ASSET__44a5a861__"